
/**Genera Ventana cuando capta error de api */

//*react- recursos
  import { useState, useEffect} from "react";
  import { object } from "yup";

//*componentes-utiles
  import { CAlert } from '@coreui/bootstrap-react'

//*clases 

//*api's (servicios y store)
  import authenticateStore from "../../api/recursos/authenticate/authenticate.store"; 
  import usersStore from "../../api/recursos/users/users.store"; 
  import catalogsStore from "../../api/recursos/catalogs/catalogs.store"; 
  import proposalsStore from "../../api/recursos/proposals/proposals.store"; 
  import notificationsStore from "../../api/recursos/notifications/notifications.store"; 
  import decisionsStore from "../../api/recursos/decisions/decisions.store"; 
  import ptCatalogsStore from "../../api/recursos/ptCatalogs/ptCatalogs.store"; 
  import filesStore from "../../api/recursos/files/files.store"; 
  import analysisStore from "../../api/recursos/analysis/analysis.store"; 
  import dashboardStore from "../../api/recursos/dashboard/dashboard.store"; 
  import configurationsStore    from "../../api/recursos/configurations/configurations.store"; 

//*store's
   import menuStore from "../../stores/menu.store"; 

//*datos

//*interfaces 
  interface propsVentanaObjError{
    recurso: string;
    objError: any;
  }

//*componente
  export default function VentanaObjError(props:propsVentanaObjError) {  //props: objErrProps
    //*api store
      const { limpiaobjErrorAuthenticateStore } = authenticateStore((state:any) =>( { limpiaobjErrorAuthenticateStore: state.limpiaobjErrorAuthenticateStore }));
      const { limpiaObjErrorNotificationsStore } = notificationsStore((state:any) =>( { limpiaObjErrorNotificationsStore: state.limpiaObjErrorNotificationsStore }));
      const { limpiaObjErrorUsersStore } = usersStore((state:any) =>( { limpiaObjErrorUsersStore: state.limpiaObjErrorUsersStore }));
      const { limpiaObjErrorCatalogsStore } = catalogsStore((state:any) =>( { limpiaObjErrorCatalogsStore: state.limpiaObjErrorCatalogsStore }));
      const { limpiaObjErrorProposalsStore } = proposalsStore((state:any) =>( { limpiaObjErrorProposalsStore: state.limpiaObjErrorProposalsStore }));
      const { limpiaObjErrorDecisionsStore } = decisionsStore((state:any) =>( { limpiaObjErrorDecisionsStore: state.limpiaObjErrorDecisionsStore }));
      const { limpiaObjErrorPtCatalogsStore } = ptCatalogsStore((state:any) =>( { limpiaObjErrorPtCatalogsStore: state.limpiaObjErrorPtCatalogsStore }));
      const { limpiaObjErrorFilesStore } = filesStore((state:any) =>( { limpiaObjErrorFilesStore: state.limpiaObjErrorFilesStore  }));
      const { limpiaObjErrorAnalysisStore } = analysisStore((state:any) =>( { limpiaObjErrorAnalysisStore: state.limpiaObjErrorAnalysisStore })); 
      const { limpiaObjErrorDashboardStore } = dashboardStore((state:any) =>( { limpiaObjErrorDashboardStore: state.limpiaObjErrorDashboardStore })); 
      const { limpiaObjErrorConfigurationsStore } = configurationsStore((state:any) =>( { limpiaObjErrorConfigurationsStore: state.limpiaObjErrorConfigurationsStore })); 

    //*store
      const { cambiaErrorPagina } =  menuStore((state:any) =>( {  cambiaErrorPagina: state.cambiaErrorPagina }));
      
    //*constantes y variables
       let objErrOmision= { hasError:false, url:'', hearder:'', recurso:'', componente:'', idresul:0, desresul:'' };

     //*usestate
       const [objErr, setObjErr] = useState(objErrOmision);

    //*useEffect
      useEffect(()=>{
        //console.log('*props.recurso:::' , props.recurso)
        window.scrollTo({top:0});
        setObjErr(props.objError);
        
        //console.log('-----objErr', objErr) 
      },[]);

    //*vista
      return (
        <>
          <div className="div-VentanaObjError">
         
            <CAlert /* style={{color:"red", backgroundColor: "#e64d3d !important "}} */
                    /* color="danger" */
                    color="info"
                    dismissible
                    onClose={ () => {
                      let paso = props.objError.menu;
                      cambiaErrorPagina(paso, true);
                      switch(props.recurso){
                        case 'authenticate': limpiaobjErrorAuthenticateStore(); break;
                        case 'analysis': limpiaObjErrorAnalysisStore();  break;
                        case 'catalogs': limpiaObjErrorCatalogsStore();  break;
                        case 'configurations': limpiaObjErrorConfigurationsStore();  break;
                        case 'dashboard': limpiaObjErrorDashboardStore();  break;
                        case 'decisions': limpiaObjErrorNotificationsStore();  break;
                        case 'files': limpiaObjErrorFilesStore();  break;
                        case 'notifications': limpiaObjErrorNotificationsStore();  break;
                        case 'proposals': limpiaObjErrorProposalsStore(); break;
                        case 'ptCatalogs': limpiaObjErrorPtCatalogsStore();  break;
                        case 'users': limpiaObjErrorUsersStore();  break;
                      }
                      setObjErr(objErrOmision);
                    }}
            >
              { props.objError.menu == 'A' 
                ? (<>
                   <h4>SSC </h4>  <br/> <br/>
                   <p>Importante: {props.objError.desresul}</p>
                
                  </>)
                : (<>
                    <h4>SSC - Errores</h4>  <br/> <br/>
                    <table className="table-VentanaObjError ">
                        <tr> <td className="align-self-center ">Error: </td>
                             <td className="align-self-center">{objErr.idresul}</td> 
                        </tr>
                        <tr> <td className="align-self-center ">Descripción: </td>
                             <td className="align-self-center ">{objErr.desresul}</td> 
                        </tr>
                        <tr> <td className="align-self-center ">URL: </td>
                             <td className="align-self-center ">{objErr.url}</td> 
                        </tr> 
                        {/* 
                        <tr> <td className="align-self-center">Entrada (hearder): </td>
                              <td className="align-self-center">{objErr.hearder}</td> 
                        </tr>
                        <tr> <td className="align-self-center ">Entrada (body): </td>
                              <td className="align-self-center">{objErr.body}</td> 
                        </tr> */}
                        <tr> <td className="align-self-center">Recurso API: </td>
                             <td className="align-self-center">{objErr.recurso}</td>
                        </tr>   
                        <tr> <td className="align-self-center">Componente: </td>
                             <td className="align-self-center">{objErr.componente}</td>
                        </tr>   
                    </table>
                  </>)
              } 
              <br />

            </CAlert>
          </div>
          
        </>
      );
  };

